import React from 'react';
import { tierBackgroundStyle, tierCrownStyle, tierParentOpacityStyle, tierParentStyle } from '../../style.vs.css';
import type { LoyaltyTierIconProps } from '../..';

export const SilverLG = ({ behavior }: Pick<LoyaltyTierIconProps, 'behavior'>) => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={behavior === 'changeOpacityOnHover' ? tierParentOpacityStyle : tierParentStyle}
    >
        <path
            d="M17.9545 1.18094C19.2203 0.450173 20.7797 0.450173 22.0455 1.18094L35.2751 8.81906C36.5408 9.54983 37.3205 10.9003 37.3205 12.3619V27.6381C37.3205 29.0997 36.5408 30.4502 35.2751 31.1809L22.0455 38.8191C20.7797 39.5498 19.2203 39.5498 17.9545 38.8191L4.72495 31.1809C3.45921 30.4502 2.67949 29.0997 2.67949 27.6381V12.3619C2.67949 10.9003 3.45921 9.54983 4.72495 8.81906L17.9545 1.18094Z"
            fill="url(#paint0_linear_1934_137603)"
            {...(behavior === 'showColorOnHover' ? { className: tierBackgroundStyle } : {})}
        />
        <path
            d="M26.8436 16.8112C26.905 16.3357 26.3801 16.0074 25.9794 16.2707L23.668 17.7896C23.5714 17.8531 23.4429 17.8364 23.3657 17.7504L20.4174 14.4651C20.1945 14.2168 19.8055 14.2168 19.5826 14.4651L16.6343 17.7504C16.5571 17.8364 16.4286 17.8531 16.332 17.7896L14.0206 16.2707C13.6199 16.0074 13.095 16.3357 13.1564 16.8112L14.1474 24.4849C14.1775 24.7179 14.3759 24.8924 14.6109 24.8924H25.3891C25.6241 24.8924 25.8225 24.7179 25.8526 24.4849L26.8436 16.8112Z"
            fill="url(#paint1_linear_1934_137603)"
            {...(behavior === 'showColorOnHover' ? { className: tierCrownStyle } : {})}
        />
        <defs>
            <linearGradient
                id="paint0_linear_1934_137603"
                x1="20"
                y1="0"
                x2="20"
                y2="40"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D6E1EA" />
                <stop offset="1" stopColor="#8795A0" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1934_137603"
                x1="20"
                y1="14"
                x2="20"
                y2="24.8924"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBFBFB" />
                <stop offset="1" stopColor="#CCD4DA" />
            </linearGradient>
        </defs>
    </svg>
);
